import React, { useContext } from 'react';
import c from 'classnames';
import CommentBox from '../../../CommentBox/presets/CommentBox';
import { CommentContext } from '../../CommentContext';
import { useReplyCommentBoxBase } from './useReplyCommentBoxBase';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './ReplyCommentBox.scss';
/** Our `CommentBox` with some comment specific props passed through. */ const ReplyCommentBox = ({ canPostComment, className, nc, onReplyPosted })=>{
    const isEditorCommentFlagEnabled = useFlag('editor_comment');
    const { id, onCancel, onPublishSuccess } = useReplyCommentBoxBase({
        onPublishSuccess: onReplyPosted
    });
    const { comment } = useContext(CommentContext);
    return /*#__PURE__*/ React.createElement(CommentBox, {
        id: id,
        className: c(s['root'], className),
        commentableType: comment.typeId,
        commentableItemId: comment.itemId,
        replyComment: comment,
        autoFocus: !isEditorCommentFlagEnabled,
        canPostComment: !!canPostComment,
        nc: nc,
        onPublishSuccess: onPublishSuccess,
        onClose: onCancel
    });
};
ReplyCommentBox.displayName = 'ReplyCommentBox';
export default ReplyCommentBox;

//# sourceMappingURL=ReplyCommentBox.js.map